import {DateTime} from 'luxon';

export default function startsIn(start: DateTime): string {
  const resetTime = {
    hour: 0, minute: 0, second: 0, millisecond: 0,
  };

  const today = DateTime.local().set(resetTime);
  const days = start.set(resetTime).diff(today).as('days');
  const fullDays = days < 0 ? Math.ceil(days) : Math.floor(days);
  if (fullDays < 0) {
    return 'started';
  } else if (fullDays <= 1) {
    if (start.day === today.day) {
      return 'today';
    }
    return 'tomorrow';
  } else if (fullDays === 1) {
    return 'tomorrow';
  } else if (fullDays > 1 && fullDays < 14) {
    return `in ${fullDays} days`;
  } else if (fullDays >= 14 && fullDays < 21) {
    return 'in 2 weeks';
  } else if (fullDays >= 21 && fullDays < 28) {
    return 'in 3 weeks';
  }
  return '';
}
